export const EVENTS_BANNER_COUNT = 4;

export const EVENT_TIME_FILTERS = {
  all: 'all',
  upcoming: 'upcoming',
  past: 'past',
} as const;

export type EventTimeFilter =
  (typeof EVENT_TIME_FILTERS)[keyof typeof EVENT_TIME_FILTERS];
